import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/CheckoutSuccess.css";

// 🌐 LIVE BACKEND URL
const BACKEND_URL = "https://rcsbackend.onrender.com"; // ⬅️ Replace with your actual Render URL

const CheckoutSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const cart = JSON.parse(localStorage.getItem("rcs_cart"));

    if (cart && cart.length > 0) {
      fetch(`${BACKEND_URL}/api/email/send-confirmation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cart }),
      })
        .then(() => {
          localStorage.removeItem("rcs_cart");
        })
        .catch((err) => {
          console.error("❌ Failed to send confirmation email:", err);
        });
    }
  }, []);

  return (
    <div className="success-container">
      <h2>✅ Payment Successful</h2>
      <p>Thank you for your purchase.</p>
      <button onClick={() => navigate("/shop")}>Back to Shop</button>
    </div>
  );
};

export default CheckoutSuccess;
